import React, { Component } from 'react'

import Form from 'editor/Form'
import FormGroup from 'editor/FormGroup'
import Label from 'editor/Label'
import TextField from 'editor/TextField'

export default class extends Component {
  render() {
    return (
      <Form>
        <FormGroup>
          <Label>Headline</Label>

          <TextField
            type="text"
            placeholder="Being gorgeous with belly side up ..."
            maxLines={4}
            value={this.props.attrs.headline || ''}
            onChange={(e) => this.props.onAttributeChange({
              key: 'headline',
              type: 'text',
              value: e.target.value
            })}
          />
        </FormGroup>

        <FormGroup>
          <Label>Tagline</Label>

          <TextField
            type="text"
            placeholder="Being gorgeous with belly side up ..."
            maxLines={4}
            value={this.props.attrs.tagline || ''}
            onChange={(e) => this.props.onAttributeChange({
              key: 'tagline',
              type: 'text',
              value: e.target.value
            })}
          />
        </FormGroup>

        <FormGroup>
          <Label>Slogan</Label>

          <TextField
            type="text"
            placeholder="Being gorgeous with belly side up ..."
            maxLines={4}
            value={this.props.attrs.slogan || ''}
            onChange={(e) => this.props.onAttributeChange({
              key: 'slogan',
              type: 'text',
              value: e.target.value
            })}
          />
        </FormGroup>
      </Form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/Header/editor.js